import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLayoutComponent } from './app-layout.component';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { RouterModule, Routes } from '@angular/router';
import { UiModule } from '../ui/ui.module';
import { ModalConfirmActionComponent } from './modal-confirm-action/modal-confirm-action.component';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchAutocompleteComponent } from './header/search-autocomplete/search-autocomplete.component';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent
  }
];

@NgModule({
    declarations: [AppLayoutComponent, HeaderComponent, NavigationComponent, ModalConfirmActionComponent, SearchAutocompleteComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        UiModule,
        NgbDropdownModule,
        NgbModule
    ]
})
export class AppLayoutModule { }
